import adapters from "./coach.group.api.queries.adapters"
import type {
    ICoachGroupSessionParticipantProgressDto,
    ICoachGroupSessionParticipantProgressModel,
    ICoachGroupSessionSummaryDto,
    ICoachGroupSessionSummaryModel
} from "./coach.group.api.types"

const summaryDto: ICoachGroupSessionSummaryDto = {
    id: -1,
    summary_data: [
        {
            title: "What is Lorem Ipsum?",
            detail: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco labo."
        },
        {
            title: "What is Lorem Ipsum? What is Lorem Ipsum?",
            detail: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et doloreexercitation ullamco laboris nisi ut aliquip ex ea."
        },
        {
            title: "What is Lorem Ipsum?",
            detail: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute."
        },
        {
            title: "What is Lorem Ipsum?",
            detail: "Lorem ipsum dolor sit amet, consectetur adipiscing elitna ali laboris nisi ut aliquip ex ea commodo consequat. Duis aute. liquip ex ea commodo consequat. Duis aute commodo consequat. Duis aute odo consequat. Duis aute. liquip ex e"
        },
        {
            title: "What is Lorem Ipsum? What is Lorem Ipsum?",
            detail: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim vequat. Duis aute."
        },
        {
            title: "What is Lorem Ipsum?",
            detail: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniut aliquip ex ea commodo consequat. Duis aute ur adipiscing elit, sed do eiusmod tempor incididunt ut labore et."
        }
    ]
}

const summaryModel: ICoachGroupSessionSummaryModel = adapters.summary(summaryDto)

function getIndividualDto({
    firstName,
    photo,
    coachPhoto
}: {
    firstName: string
    photo: string | null
    coachPhoto: string | null
}): ICoachGroupSessionParticipantProgressDto {
    return {
        id: 1,
        first_name: firstName,
        photo,
        last_name: "LastName",
        is_guest: false,
        journey_length: 3,
        module_progress: {
            title: "Inspiration",
            rank: 1,
            associated_session: { id: 1, status: "accepted", is_manual: false, coach: { id: 1, photo: coachPhoto } },
            phases: [
                { id: 0, track_status: "on_track", phase_progress_bar: 3 },
                { id: 1, track_status: "late", phase_progress_bar: 2 },
                { id: 2, track_status: "late", phase_progress_bar: 2 },
                { id: 3, track_status: "late", phase_progress_bar: 1 }
            ]
        },
        module_summary: null
    }
}

function getIndividualModel(): ICoachGroupSessionParticipantProgressModel {
    return adapters.individualProgress(getIndividualDto({ firstName: "Name", photo: null, coachPhoto: null }))
}

export default {
    dtos: { summary: summaryDto, getIndividualDto },
    models: { summary: summaryModel, getIndividualModel }
}
